import type { RmkSourceSummary } from '../platform/rmkSourceTypes'

const NO_WORK: RmkSourceSummary = { ownWork: false, lines: ['Оборудование: кассовый агент этого компьютера'] }

/**
 * Сводка плитки источника «Собственная»: смен и сессий на сервере у него нет (оборудование на компьютере кассира), поэтому
 * «своей работы» для автоперехода нет — плитки не пропускаются, а строка поясняет, чем продаём.
 */
export function useOwnRmkSummary(): RmkSourceSummary {
  return NO_WORK
}
